module.exports = __webpack_public_path__ + "img/therapeutenverbund_logo.2cf6b5d2.jpg";